import ArrowRight from '@/legacy/components/ui/Icons/ArrowRight';
import { CrownIcon } from '@/shared/ui/icons';
import { Button, Tooltip } from '@frekuent/orbit/components';
import { Link, useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

type AddonNavItemProps = {
	collapsed: boolean;
};

const AddonNavItem = ({ collapsed }: AddonNavItemProps) => {
	const { t } = useTranslation('marketplace');
	const navigate = useNavigate();

	if (collapsed) {
		return (
			<div className='-mb-3'>
				<Tooltip
					content={t('upsellCard.title')}
					placement='right'
					size='small'
				>
					<Link
						to={'/app/marketplace'}
						aria-label={t('upsellCard.title')}
						className='w-fit'
					>
						<div className='w-8 h-8 flex items-center justify-center rounded-lg bg-news-banner-premium'>
							<CrownIcon
								width={18}
								height={18}
							/>
						</div>
					</Link>
				</Tooltip>
			</div>
		);
	}

	return (
		<div className='flex flex-col justify-center items-start py-5 px-4 -mb-3 gap-2 rounded-lg bg-news-banner-premium'>
			<div className='flex items-center gap-2 w-full'>
				<CrownIcon
					width={18}
					height={18}
				/>
				<span className='font-medium text-sm leading-none tracking-normal text-primary'>
					{t('upsellCard.title')}
				</span>
			</div>

			<p className='font-sans font-normal leading-none text-sm text-primary'>
				{t('upsellCard.description')}
			</p>

			<Button
				type='button'
				className='text-sm gap-1 leading-none'
				size='small'
				onClick={() => navigate('/app/marketplace')}
				endAdornment={<ArrowRight className='size-4' />}
			>
				{t('upsellCard.cta')}
			</Button>
		</div>
	);
};

export default AddonNavItem;
